import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import PageHeader from '../components/PageHeader';
import Reveal from '../components/ui/Reveal';
import SectionHeading from '../components/ui/SectionHeading';
import { ReelCard, ReelPlayer } from '../components/home/ReelsSection';
import { reels } from '../data/reels';
import { site } from '../data/site';
import { showroom } from '../data/collections';
import usePageMeta from '../hooks/usePageMeta';
import { IconInstagram } from '../components/ui/Icons';

export default function Reels() {
  const [playing, setPlaying] = useState(null);

  usePageMeta({
    title: 'Reels | Pramukh Jewellers, Ahmedabad',
    description:
      'Watch the Pramukh Jewellers collection in motion — bridal layering, antique nakashi gold and the Maharani Heritage collection.',
    path: '/reels',
  });

  return (
    <>
      <PageHeader
        eyebrow="In motion"
        title="Reels"
        lede="Gold reads differently on video — the shadow in the nakashi, the way a haram falls. Tap any reel to play."
        image={showroom.reception}
        crumbs={[{ label: 'Home', to: '/' }, { label: 'Reels' }]}
      />

      <section className="bg-cream py-16 lg:py-24">
        <div className="shell">
          <div className="grid grid-cols-2 gap-4 sm:gap-5 lg:grid-cols-3">
            {reels.map((r, i) => (
              <Reveal key={r.id} delay={(i % 3) * 80}>
                <ReelCard reel={r} index={i} onPlay={setPlaying} />
              </Reveal>
            ))}
          </div>

          <Reveal delay={120} className="mt-14 text-center">
            <p className="text-sm font-light text-royal/70">
              New reels go up on Instagram first.
            </p>
            <a
              href={site.social.instagram}
              target="_blank"
              rel="noopener noreferrer"
              className="btn-primary mt-5"
            >
              <IconInstagram className="h-4 w-4" />
              Follow @pramukhjewellers
            </a>
          </Reveal>
        </div>
      </section>

      <section className="relative overflow-hidden bg-royal py-16 lg:py-24">
        <div className="pointer-events-none absolute inset-0 paisley-bg opacity-[0.14]" />
        <div className="shell relative flex flex-col items-center gap-8 text-center lg:flex-row lg:justify-between lg:text-left">
          <SectionHeading
            align="left"
            tone="light"
            eyebrow="See it in person"
            title="Better in the hand"
            lede="Everything in these reels is on the floor at Science City Road. Come and try it on."
            className="lg:mx-0"
          />
          <Reveal delay={100} className="flex shrink-0 flex-wrap items-center justify-center gap-x-10 gap-y-4">
            <Link to="/collections" className="btn-line-light">
              <span className="btn-line-rule" />
              Browse collections
            </Link>
            <Link
              to="/contact"
              className="text-[12px] font-medium uppercase tracking-luxe text-cream/70 transition-colors duration-500 hover:text-gold-200"
            >
              Visit us
            </Link>
          </Reveal>
        </div>
      </section>

      {playing !== null && (
        <ReelPlayer list={reels} index={playing} onIndex={setPlaying} onClose={() => setPlaying(null)} />
      )}
    </>
  );
}
